export default __webpack_public_path__ + "assets/4ec09a3195bd1dae9254190f4f50542d.png";